var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"loader"},[_c('p',[_vm._t("default",function(){return [_vm._v(_vm._s(_vm._f("locale")("general.loading")))]})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }